import { Injectable } from '@angular/core';
import { Project } from './project';
import { ArcService } from './arc.service'
import { BatchSearch } from './batch-search'

@Injectable()
export class BatchSearchService {

  constructor(private arcs: ArcService) { }

  init(p: Project) {
    let obs = this.arcs.run({
      fun: 'getProjectBatchSearches',
      project: p.shortcut
    })
    obs.subscribe((resp) => {
      resp.forEach(x => new BatchSearch(this, p, x))
    })
  }

  makeCurrent(p: Project, b: BatchSearch) {
    let obs = this.arcs.run({
      fun: 'setCurrentBatchSearch',
      project: p.shortcut,
      batchSearchFilename: b.filename
    })
    obs.subscribe((resp) => {
      p.setCurrentBatchSearch(b.id)
    })
  }

  delete(p: Project, b: BatchSearch) {
    let obs = this.arcs.run({
      fun: 'deleteBatchSearch',
      project: p.shortcut,
      batchSearchFilename: b.filename
    })
    obs.subscribe((resp) => {
      p.batchSearchMap.delete(b.id)
    })
  }


}



// WEBPACK FOOTER //
// ./src/app/batch-search.service.ts